<template>
  <v-navigation-drawer v-model="drawer" v-if="show && !user.tecnico" app color="white" left permanent width="280" mini-variant
    :mini-variant="mini" mini-variant-width="80">
    <v-toolbar color="rgba(0,0,0,0)" flat>
      <v-toolbar-title v-if="!mini">Acesso rápido</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleMini">
        <v-icon color="black">{{ mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right' }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-list subheader two-line class="mt-1">
      <v-list-item v-for="(item, index) in itens" :key="item.titulo" @click="$emit('selecionado', index)">
        <v-list-item-avatar>
          <v-icon :color="item.cor" large dark v-text="item.icone" ></v-icon>
        </v-list-item-avatar>
        <v-list-item-content v-if="!mini">
          <v-list-item-title v-text="item.titulo"></v-list-item-title>
          <v-list-item-subtitle v-text="item.subtitulo"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-if="!mini">
      <v-row dense>
    <!-- <v-btn :disabled="!user.servicosEscolhidos" color="blue" dark elevation="0" class="mb-4" block @click="mostrarTela">Mudar local</v-btn> -->

        <v-col cols="12" class="pb-4" v-for="(cardGroup, index) in metricCards" :key="index">
          <v-card class="mx-2 rounded-l-xl mb-2" flat color="#EEEEEE">
            <v-row align="center">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="ml-3 font-weight-bold text-h7"
                    v-text="cardGroup.period"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-col v-for="(metric, idx) in cardGroup.metrics" :key="idx" cols="6">
                <v-card outlined :color="metric.color" class="mx-2 d-flex justify-center align-center text-center"
                  height="80px">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-h7 white--text" v-text="metric.subtitle"></v-list-item-subtitle>
                    <span class="text-h6 white--text font-weight-bold">
                      {{ metric.value || 'N/A' }}
                    </span>
                  </v-list-item-content>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { EventBus } from '../main'
import medicoService from '../services/medico.service'

export default {
  props: {
    initialMini: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    drawer: true,
    mini: false,
    show: true,
    user: '',
    mediaTempoAtendimentoDiario: '',
    totalAtendimentosDiario: '',
    mediaTempoAtendimentoMensal: '',
    totalAtendimentosMensal: '',
    mediaTempoAtendimentoAnual: '',
    totalAtendimentosAnual: '',
    metricCards: [],
    itens: [
      {
        cor: 'primary',
        icone: 'person_search',
        titulo: 'Meus Pacientes'
      },
      {
        cor: '#FE7975',
        icone: 'fas fa-heartbeat',
        titulo: 'Meus Atendimentos'
      },
      {
        cor: 'grey',
        icone: 'settings',
        subtitulo: 'Configurações',
        titulo: 'Pré-definições'
      }
    ]
  }),
  methods: {
    mostrarTela () {
      EventBus.$emit('mostrarTelaPrincipal', true)
    },
    toggleMini () {
      this.mini = !this.mini
    },
    retornarMetricasMensalAnual () {
      medicoService.medico
        .retornarMetricasDeAtendimentoMensaisAnuais(this.user.id)
        .then((r) => {
          if (r.status === 200) {
            console.log(r.data.metricas)
            var metricas = r.data.metricas

            this.mediaTempoAtendimentoMensal = metricas && metricas.mensal && metricas.mensal.media ? metricas.mensal.media.toFixed(1) : 0
            this.totalAtendimentosMensal = metricas && metricas.mensal ? metricas.mensal.quantidade : 0
            this.mediaTempoAtendimentoAnual = metricas && metricas.anual && metricas.anual.media ? metricas.anual.media.toFixed(1) : 0
            this.totalAtendimentosAnual = metricas && metricas.anual ? metricas.anual.quantidade : 0
            this.atualizarMetricCards()
          }
        })
    },
    retornarMetricasDiarias () {
      const dataAtual = new Date()
      const dataFormatada = `${dataAtual.getFullYear()}-${String(dataAtual.getMonth() + 1).padStart(2, '0')}-${String(dataAtual.getDate()).padStart(2, '0')}`

      medicoService.medico
        .retornarMetricasDeAtendimento(this.user.id, dataFormatada, dataFormatada)
        .then((r) => {
          if (r.status === 200) {
            this.mediaTempoAtendimentoDiario = r.data.mediaMinutos ? r.data.mediaMinutos.toFixed(1) : 0
            this.totalAtendimentosDiario = r.data.quantidade
            this.atualizarMetricCards()
          }
        })
    },
    atualizarMetricCards () {
      this.metricCards = [
        {
          period: 'HOJE',
          metrics: [
            {
              subtitle: 'Total',
              color: 'green lighten-2',
              value: this.totalAtendimentosDiario
            },
            {
              subtitle: 'Média min.',
              color: 'blue lighten-2',
              value: this.mediaTempoAtendimentoDiario
            }
          ]
        },
        {
          period: this.getMonthName().toUpperCase(),
          metrics: [
            {
              subtitle: 'Total',
              color: 'teal lighten-2',
              value: this.totalAtendimentosMensal
            },
            {
              subtitle: 'Média min',
              color: 'purple lighten-2',
              value: this.mediaTempoAtendimentoMensal
            }
          ]
        },
        {
          period: this.getYear(),
          metrics: [
            {
              subtitle: 'Total',
              color: 'red lighten-2',
              value: this.totalAtendimentosAnual
            },
            {
              subtitle: 'Média min.',
              color: 'orange lighten-2',
              value: this.mediaTempoAtendimentoAnual
            }
          ]
        }
      ]
    },
    getMonthName () {
      const dataAtual = new Date()
      return dataAtual.toLocaleString('default', { month: 'long' })
    },
    getYear () {
      return new Date().getFullYear()
    }
  },
  watch: {
    initialMini (val) {
      this.mini = val
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarMetricasMensalAnual()
    this.retornarMetricasDiarias()
    window.addEventListener('resize', this.checkScreenWidth)
    EventBus.$on('showSideBar', (data) => {
      this.show = data
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenWidth)
    EventBus.$off('showSideBar')
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}

.text-h6 {
  font-size: 1rem;
}
</style>
